import { Component, OnInit, Input } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { Router } from '@angular/router';
import { ADPResourceService } from 'digital-core';

@Component({
  selector: "adp-image",
  templateUrl: "./adp-image.component.html",
  styleUrls: ['./adp-image.component.scss'],
})

export class ADPImageComponent implements OnInit {
  @Input() imageKey: string;
  @Input() imageClass: string;
  @Input() imageAlt: string;
  transformedSpanContent: SafeHtml = '';
  transformedImgContent = '';
  transformedImageAlt = '';
  public constructor(
    public resourcesService: ADPResourceService,
    private router: Router,
    private domSanitizer: DomSanitizer,
  ) { }

  ngOnInit() {
    if (this.resourcesService.getPortalImage(this.imageKey).ImageContent == "") {
      this.transformedImgContent = this.resourcesService.getPortalImage(this.imageKey).ImageURL;
    } else {
      this.transformedSpanContent = this.domSanitizer.bypassSecurityTrustHtml(this.resourcesService.getPortalImage(this.imageKey).ImageContent);
    }
    if(this.imageAlt)
      this.transformedImageAlt = this.imageAlt ?? this.imageKey;
    else
      this.transformedImageAlt = this.resourcesService.getPortalImage(this.imageKey)['Caption'];
  }
}
